import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initPostHog } from './lib/analytics/posthog';

initPostHog();

// ResizeObserver "loop completed with undelivered notifications" is a benign browser quirk.
// Primary dev-overlay suppression is in public/index.html (must register before webpack's overlay).
if (typeof window !== 'undefined') {
  const isResizeObserverNoise = (message: unknown): boolean => {
    if (typeof message === 'string') {
      return message.includes('ResizeObserver');
    }
    if (message instanceof Error) {
      return message.message.includes('ResizeObserver');
    }
    return false;
  };

  const originalError = console.error;
  console.error = (...args) => {
    if (isResizeObserverNoise(args[0])) {
      return;
    }
    originalError.apply(console, args);
  };

  const prevOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (isResizeObserverNoise(message) || isResizeObserverNoise(error)) {
      return true;
    }
    return prevOnError ? prevOnError.call(window, message, source, lineno, colno, error) : false;
  };

  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
